import { useState } from 'react';

// project import
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { UpdateBanner } from 'components/version/UpdateBanner';
import ConcurrentEditingIndicatorBar from './ConcurrentEditingIndicatorBar.tsx';
import EnvIndicatorBar from './EnvIndicatorBar.tsx';
import { HeaderContent } from './HeaderContent';
import ImpersonationIndicatorBar from './ImpersonationIndicatorBar.tsx';
import MaintenanceIndicatorBar from './MaintenanceIndicatorBar.tsx';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

type HeaderProps = {
    focusedMode?: boolean;
};

const Header = ({ focusedMode = false }: HeaderProps) => {
    const [searchOpen, setSearchOpen] = useState(false);

    return (
        <div>
            <MaintenanceIndicatorBar />
            <EnvIndicatorBar />
            <UpdateBanner />
            <ImpersonationIndicatorBar />
            <ConcurrentEditingIndicatorBar />
            {!focusedMode && (
                <>
                    {/*
                     * Dims the page while the search bar is focused, and has to stay under the
                     * chrome. `--z-popover` and `--z-nav` are the same level, so what decides it is
                     * that this is painted before the header: portalling it, or moving it after,
                     * would put it over the header instead.
                     */}
                    {searchOpen && <div aria-hidden className="bg-backdrop fixed inset-0 z-(--z-popover)" />}
                    <header className="border-divider bg-paper sticky top-0 z-(--z-nav) w-full border-b">
                        {/*
                         * From `sm` up: breadcrumbs, search bar, actions. The trail spans the first two
                         * columns, so a long one runs on under the bar rather than wrap in a column the
                         * bar has squeezed. The row is also the container the design switch measures.
                         */}
                        <div className="relative flex flex-col gap-2 p-2 sm:@container sm:grid sm:h-14 sm:grid-cols-[minmax(0,1fr)_minmax(0,auto)_minmax(max-content,1fr)] sm:items-center sm:gap-0 sm:p-0 sm:px-6 sm:[&>nav]:col-[1/3] sm:[&>nav]:row-start-1">
                            <Breadcrumbs />
                            <HeaderContent onSearchOpenChange={setSearchOpen} />
                        </div>
                    </header>
                </>
            )}
        </div>
    );
};

export default Header;
